import { render, staticRenderFns } from "./SalesCategory.vue?vue&type=template&id=b860ad12&scoped=true"
import script from "./SalesCategory.vue?vue&type=script&lang=js"
export * from "./SalesCategory.vue?vue&type=script&lang=js"
import style0 from "./SalesCategory.vue?vue&type=style&index=0&id=b860ad12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b860ad12",
  null
  
)

export default component.exports